// Librerías externas
require("select2/dist/js/select2.min");
require("select2/dist/js/i18n/es.js");
